import React from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { 
  Home, 
  Shirt, 
  User, 
  ShoppingBag, 
  Settings 
} from "lucide-react";

const items = [
  { path: "/dashboard", icon: Home, label: "Accueil" },
  { path: "/dressing", icon: Shirt, label: "Dressing" },
  { path: "/outfits", icon: User, label: "Outfits" },
  { path: "/suggestions", icon: ShoppingBag, label: "Suggestions" },
  { path: "/settings", icon: Settings, label: "Paramètres" },
];

export default function Sidebar() {
  const { pathname } = useLocation();

  return (
    <>
      {/* Sidebar desktop */}
      <aside className="hidden md:flex fixed left-4 top-1/2 -translate-y-1/2 z-40">
        <motion.nav 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
          className="rounded-2xl bg-white/95 backdrop-blur-md text-gray-900 shadow-soft border border-gray-200/50 px-4 py-6 flex flex-col items-center gap-6 w-[80px]"
        >
          {items.map(({ path, icon: Icon, label }, index) => {
            const active = pathname.startsWith(path);
            return (
              <motion.div
                key={path}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
              >
                <Link
                  to={path}
                  className={`group flex flex-col items-center gap-2 transition-all duration-300`}
                  title={label}
                >
                  <motion.div
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.95 }}
                    className={`w-12 h-12 rounded-xl grid place-items-center transition-all duration-300 ${
                      active 
                        ? "bg-black text-white shadow-medium" 
                        : "bg-gray-100 group-hover:bg-gray-200 text-gray-600 group-hover:text-gray-900"
                    }`}
                  >
                    <Icon className="w-5 h-5" />
                  </motion.div>
                  <span className={`text-[10px] font-medium transition-colors duration-300 ${
                    active ? "text-black" : "text-gray-500 group-hover:text-gray-700"
                  }`}>
                    {label}
                  </span>
                </Link>
              </motion.div>
            );
          })}
        </motion.nav>
      </aside>

      {/* Bottom nav mobile */}
      <motion.nav
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-gray-200/50 shadow-[0_-2px_10px_rgba(0,0,0,0.05)]"
        role="navigation"
        aria-label="Navigation principale"
      >
        <div className="flex justify-around items-center px-4 py-3">
        {items.map(({ path, icon: Icon, label }, index) => {
          const active = pathname.startsWith(path);
          return (
            <motion.div
              key={path}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
            >
              <Link
                to={path}
                className={`px-3 py-2 rounded-xl flex flex-col items-center gap-1.5 transition-all duration-300
                            ${active 
                              ? "bg-black text-white shadow-medium" 
                              : "text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                            }`}
                aria-current={active ? "page" : undefined}
              >
                <motion.div
                  whileTap={{ scale: 0.9 }}
                  className="flex items-center justify-center"
                >
                  <Icon className="w-5 h-5" />
                </motion.div>
                <span className="text-[10px] font-medium leading-tight text-center">
                  {label}
                </span>
              </Link>
            </motion.div>
          );
        })}
        </div>
      </motion.nav>

    </>
  );
}
